import {connect} from "react-redux";
import ComplaintForCentralTech from "./ComplaintForCentralTech";
import {bindActionCreators} from "redux";
import {
    siteData,
} from "../../../../services/redux/MaterialRequistionForm/action";
import {documentUploadUrlPublic} from 'services/redux/fileUpload/action';
import {centralTechComplainRaise} from "../../../../services/redux/fileComplain/action";

const mapStateToProps = (state) => ({
    siteDetails: state.MaterialRequistionForm.siteDetails,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            siteData,
            documentUploadUrlPublic,
            centralTechComplainRaise
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintForCentralTech);
